import { isPlatformBrowser } from '@angular/common';
import { EventEmitter, Injectable, PLATFORM_ID, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProgressService {
  private platformId = inject<object>(PLATFORM_ID);

  private $navigation = new EventEmitter<boolean>();

  private $pageLoad = new EventEmitter<boolean>();

  private $menuToggle = new BehaviorSubject<boolean>(false);

  get navigation() {
    return this.$navigation;
  }

  get pageLoad() {
    return this.$pageLoad;
  }

  get menuToggle() {
    return this.$menuToggle;
  }

  navigationStart() {
    this.$navigation.emit(true);
  }

  navigationEnd() {
    this.$navigation.emit(false);
  }

  pageLoadStart() {
    this.$pageLoad.emit(true);
  }

  pageLoadEnd() {
    this.$pageLoad.emit(false);
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo(0, 0);
    }
  }
}
